export default __webpack_public_path__ + "static/media/efuneral.1d44e205.png";